import React, { useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { TPeriod, TPurchaseOptionsProps } from '@r1-frontend/ui-react/components/costs/PurchaseOptions/types';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { IndentContainer, ListContainer, withRadius } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import Installment from './Installment';
import Purchase from './Purchase';

const PO = ({
    options,
    onSelect,

    ...props
}: TPurchaseOptionsProps): JSX.Element => {
    const {
        1: purchaseOption,
        ...elseOptions
    } = options;

    const [selectedOption, setOption] = useState<{ cost: number, period: TPeriod } | undefined>(undefined);

    const handleSelect = (cost: number, period: TPeriod) => () => {
        setOption({ cost, period });
    };

    const handleConfirm = () => {
        if (selectedOption) {
            onSelect(selectedOption.cost, selectedOption.period);
        }
    };

    return (
        <IndentContainer $united={[16]} {...props}>
            <H4>Варианты покупки</H4>
            <ListContainer $size={12} $direction={'column'}>
                {purchaseOption && <Purchase {...purchaseOption} onSelect={handleSelect}/>}
                {!isEmpty(elseOptions) && (
                    <Installment options={elseOptions} onSelect={handleSelect}/>
                )}
                <Button bType={'action'} disabled={!selectedOption} onClick={handleConfirm}>
                    Добавить
                </Button>
            </ListContainer>
        </IndentContainer>
    );
};

export default styled(withRadius(PO, { $radius: 24 }))`
    background-color: ${COLORS.BgSurface};
    width: 100%;

    & ${Button} {
        width: 100%;
    }
`;
